import { module } from 'angular';


class CopyStageCardComponent implements ng.IComponentOptions {
  public bindings: any = {
    stageWrapper: '<'
  };
  public template = `
    <div class="row">
      <div class="col-md-10">
        <b>{{::$ctrl.stageWrapper.stage.name}}</b>
      </div>
      <div class="col-md-2">
        <cloud-provider-logo ng-if="$ctrl.stageWrapper.stage.cloudProviderType"
                             class="pull-right"
                             height="'10px'"
                             width="'10px'"
                             provider="$ctrl.stageWrapper.stage.cloudProviderType">
        </cloud-provider-logo>
      </div>
    </div>
    <p><b>Type:</b> {{::$ctrl.stageWrapper.stage.type | robotToHuman}}</p>
    <p ng-if="$ctrl.stageWrapper.pipeline"><b>Pipeline:</b> {{::$ctrl.stageWrapper.pipeline}}</p>
    <p ng-if="$ctrl.stageWrapper.strategy"><b>Strategy:</b> {{::$ctrl.stageWrapper.strategy}}</p>
    <p class="small">{{::$ctrl.stageWrapper.stage.comments}}</p>
  `;
}

export const COPY_STAGE_CARD_COMPONENT = 'spinnaker.core.copyStageCard.component';

module(COPY_STAGE_CARD_COMPONENT, []).component('copyStageCard', new CopyStageCardComponent());



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./app/scripts/modules/core/src/pipeline/config/copyStage/copyStageCard.component.ts